module.exports = __webpack_public_path__ + "static/media/coin_icon.38a10006.png";